import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
} from '@chakra-ui/react'
import { ReportType } from '../types'
import { reportTitles, DATE_REQUIRED_REPORTS } from '../utils/reportConstants'

interface Props {
  reportType: ReportType | ''
  startDate: string
  endDate: string
  onReportTypeChange: (type: ReportType | '') => void
  onStartDateChange: (date: string) => void
  onEndDateChange: (date: string) => void
}

export default function ReportFilters({
  reportType,
  startDate,
  endDate,
  onReportTypeChange,
  onStartDateChange,
  onEndDateChange,
}: Props) {
  return (
    <SimpleGrid columns={[1, 2, 3]} spacing={4}>
      <FormControl>
        <FormLabel>Report Type</FormLabel>
        <Select
          placeholder='Select report type'
          value={reportType}
          onChange={(e) => onReportTypeChange(e.target.value as ReportType)}
        >
          {Object.entries(reportTitles).map(([key, title]) => (
            <option key={key} value={key}>
              {title}
            </option>
          ))}
        </Select>
      </FormControl>
      {DATE_REQUIRED_REPORTS.has(reportType as ReportType) ? (
        <>
          <FormControl>
            <FormLabel>Start Date</FormLabel>
            <Input
              type='date'
              value={startDate}
              onChange={(e) => onStartDateChange(e.target.value)}
            />
          </FormControl>
          <FormControl>
            <FormLabel>End Date</FormLabel>
            <Input
              type='date'
              value={endDate}
              onChange={(e) => onEndDateChange(e.target.value)}
            />
          </FormControl>
        </>
      ) : (
        // placeholders to keep grid layout consistent
        <>
          <Box />
          <Box />
        </>
      )}
    </SimpleGrid>
  )
}
